import {Fragment} from "react";
import {Box} from "@mui/system";
import styles from "../../../views/Vote/voteMainStyles";
import _ from 'lodash';
import ConversationInfoEmptyState from "./EmptyStates/ConversationInfoEmptyState";
import ConversationDuration from "./ConversationDuration";
import {getPlatform, PLATFORM} from "../../../views/Messages/MessageDetails/Utilities/MessageDetailsUtils";

export default function ConversationInfo({ message, loading }) {
    const platform = getPlatform(_.get(message, 'id'));

    const getConversationInfo = (message) => {
        if(_.isEmpty(message)) return '';
        const handleName = _.get(message, 'dataSourceHandle.name') || _.get(message, 'handle.name');

        return (
            <Fragment>
                <Box component={"span"} className={"capitalize"}>
                    {handleName}
                </Box>
                {platform !== PLATFORM.VOTE && (
                    <Box component={"span"} sx={{ paddingTop: "6px" }}>
                        <ConversationDuration message={message} />
                    </Box>
                )}
            </Fragment>
        );
    }

    const info = getConversationInfo(message);

    return(
        <Box sx={styles.heading}>
            { loading ? <ConversationInfoEmptyState/> : info }
        </Box>
    )
}